var NAME = "Pranav Vijay";

var TYPE_DELAY = 80;

export { NAME, TYPE_DELAY };
